<template>
  <div
    style="
      width: 800px;
      height: 800px;
      position: absolute;
      left: 50%;
      top: 50%;
      margin-left: -400px;
      margin-top: -400px;
    "
    class="s-new-theme"
  >
    <div class="login-content-box">
      <div class="login-content-box-1">
        <div class="login-content-box-1-top">
          <!-- <p class="p1" @click="$router.push('blogin')">验证码登录</p> -->
          <p class="p2 s-red-color">展商登录</p>
          <!-- Switch to English -->
          <p class="p2 s-red-color" @click="linkEn" style="cursor: pointer">
            <span
              style="border-radius: 50%; border: 1px solid rgb(209, 49, 25); padding: 5px"
              >En</span
            >
          </p>
          <!-- <p class="p2 p3" @click="linkHost">主办登录</p> -->
        </div>
        <div class="login-content-box-1-bottom">
          <Form
            class="F"
            ref="formInline"
            :model="formInline"
            :rules="ruleInline"
            @keyup.enter.native="handleSubmit('formInline')"
          >
            <FormItem class="F-1" prop="user">
              <Input
                class="I"
                type="text"
                v-model="formInline.user"
                placeholder="用户名"
              />
            </FormItem>
            <FormItem class="F-1" prop="password">
              <Input
                class="I"
                type="password"
                v-model="formInline.password"
                placeholder="密码"
              />
            </FormItem>
            <FormItem class="F-1" prop="captcha">
              <Input class="I" v-model="formInline.captcha" placeholder="验证码" />
              <img
                class="code"
                :src="code.image"
                alt="验证码"
                v-if="code && code.image"
                @click="getCode"
              />
            </FormItem>
            <div class="F-2">
              <Checkbox class="save-btn" v-model="remember"
                >&nbsp;&nbsp;&nbsp;记住我</Checkbox
              >
              <p
                class="F-2-text"
                style="font-size: 14px; width: 60px; color: #515a6e"
                @click="openRetrievePasswordHandle"
              >
                忘记密码
              </p>
            </div>

            <Button
              type="primary"
              @click="handleSubmit('formInline')"
              size="large"
              class="s-btn-red"
              :loading="loading"
              >登录</Button
            >
            <!-- <Button class="wx-btn" @click="$router.push('clogin')" size="large">
            <span class="wx-icon">
              <img src="../img/weixin.png" alt="微信" />
            </span>微信扫码登录
          </Button>-->
          </Form>
        </div>
      </div>
    </div>
    <!-- <div class="login-content-text">
      <h3>展商中心</h3>
      <p>尊敬的展商，欢迎参加CMEF展会</p>
      <p>请登录进入展商中心，完善您的企业、产品信息</p>
      <p>您填写的每一个文字都将在线上线下为您的企业宣传发挥价值！</p>
    </div> -->
<!-- 
    <iModal
      style="width: 600px"
      v-model="modelRemind"
      title="提示"
      class-name="vertical-center-modal"
      :footer-hide="true"
      :mask-closable="false"
      :closable="false"

    >
      <div style="margin: 10px 15px 15px">
        <h3 style="text-align: center; margin-bottom: 10px">“三个承诺”之参展商承诺</h3>
        <p>
          &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp本人承诺：主动上报本人与其他单位、个人等主体间发生的尚未处理完毕的各类矛盾纠纷，积极配合本人所在地司法调解部门做好矛盾纠纷化解工作，不将矛盾纠纷带到展会现场，如因本人未如实上报相关情况，造成展会现场发生滋事扰序等情况的，本人愿意承担相关法律责任。
        </p>
        <p>
          &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp本人承诺：切实提高安全防范意识，全民参与防范电信网络诈骗，不听、不信、不转账，不贪、不要、不上当，一旦难分真假，务必第一时间拨打国展派出所电话021-59720110咨询求助。
        </p>
        <p>
          &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp本人承诺：严格遵守国展中心禁限带物品进馆要求，不将明文规定的禁限带物品和与此次展会活动无关的物品带入场馆，如有违反本人愿意承担相关法律责任。注：禁带物品是指违反中国法律法规的物品；限带物品是指虽然不违反中国法律法规，但可能影响国展中心安全和运营秩序，不得带入的物品。展品中如有刀具等涉及禁、限带物品的，要在展品进入国展中心前以书面形式（包括种类数量、入场时间、安全管理措施等）向安保部门备案。
        </p>
      </div>
      <div class="button s-btn-red" @click="modelRemind = false">我已知晓</div>
    </iModal> -->

    <div v-if="showPrivacyPolicy" class="privacy-policy">
      <div
        style="display: flex; justify-content: end; cursor: pointer"
        @click="hidePrivacyPolicy"
      >
        X
      </div>
      <div style="display: flex; justify-content: space-around; align-items: center">
        <p>
          iCMEF是国药励展CMEF唯一官方出品“全球医疗健康产业线上空间”，主要提供CMEF展商及产品的搜索、供需发布及对接、商务洽谈、获取门票等在线服务。请认准iCMEF官方网站（i.cmef.com.cn）及小程序（“iCMEF”
          ） ，谨防诈骗，避免不必要的损失。
        </p>
        <Button type="primary" @click="hidePrivacyPolicy()" size="large" class="s-btn-red"
          >全部接受</Button
        >
      </div>
    </div>

    <!-- 忘记密码弹窗 -->
    <RetrievePassword
      :open="retrievePasswordVisible"
      :userData="userData"
      @resetForm="resetForm"
    />
  </div>
</template>

<script>
import CryptoJS from "crypto-js";
import { mapActions, mapMutations, mapGetters } from "vuex";
import config from "@assets/config.json";
import RetrievePassword from "./RetrievePassword.vue";

export default {
  components: {
    RetrievePassword,
  },
  data() {
    return {
      showPrivacyPolicy: true,
      modelRemind: true,
      resetShow1: false,
      resetShow2: false,
      resetShow3: false,
      showCode: true, // 是否可以获取验证码
      count: "", // 获取验证码的秒数
      formReset1: {
        user: "",
        phone: "",
        email: "",
        captcha: "",
      },
      ruleReset1: {
        user: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        phone: [{ required: true, message: "请输入手机号码", trigger: "blur" }],
        email: [{ required: true, message: "请输入邮箱", trigger: "blur" }],
        captcha: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
      formReset2: {
        password: "",
        copyPassword: "",
      },
      ruleReset2: {
        password: [
          { required: true, message: "密码不能为空", trigger: "blur" },
          {
            type: "string",
            min: 4,
            message: "密码不能小于4位",
            trigger: "blur",
          },
          {
            type: "string",
            max: 50,
            message: "密码不能大于50位",
            trigger: "blur",
          },
        ],
        copyPassword: [
          { required: true, message: "密码不能为空", trigger: "blur" },
          {
            type: "string",
            min: 4,
            message: "密码不能小于4位",
            trigger: "blur",
          },
          {
            type: "string",
            max: 50,
            message: "密码不能大于50位",
            trigger: "blur",
          },
        ],
      },
      formReset3: {
        phone: "",
        captcha: "",
      },
      ruleReset3: {
        phone: [{ required: true, message: "请输入手机号码", trigger: "blur" }],
        captcha: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
      passedPhone: "",
      passedCaptcha: "",

      formInline: {
        user: "",
        password: "",
        // user: "YAMII",
        // password: "888888",
        // user: "leeeeee",
        // password: "ly19930124",
        captcha: "",
      },
      ruleInline: {
        user: [{ required: true, message: "用户为必填选项", trigger: "blur" }],
        password: [
          { required: true, message: "账号或密码错误", trigger: "blur" },
          {
            type: "string",
            min: 4,
            message: "密码不能小于4位",
            trigger: "blur",
          },
          {
            type: "string",
            max: 50,
            message: "密码不能大于50位",
            trigger: "blur",
          },
        ],
        captcha: [{ required: true, message: "验证码必填", trigger: "blur" }],
      },
      code: null, // 二维码信息
      remember: false, // 记住我
      loading: false,
      exhibitionId: "",
      phoneType: 1,
      userInfo: {},
      retrievePasswordVisible: false, //忘记密码
      userData: {
        //用户账号信息
        phone: "",
        email: "",
        user: "",
      },
    };
  },
  async created() {
    // 获取当前时间戳（可以用其它随机值，保证每次请求不同）
    const timestamp = new Date().getTime();

    // 获取当前页面的 URL
    let currentUrl = window.location.href;

    // 检查 URL 是否已经有查询参数
    if (currentUrl.indexOf("?") === -1) {
      // 如果没有查询参数，则直接在 URL 后添加时间戳
      currentUrl += `?t=${timestamp}`;
      window.location.href = currentUrl;
      return;
    }

    await this.getAllConfiSettle("exhibition");
    this.getCode();
    this.init();
    console.log("ExhibitionIdArr", this.ExhibitionIdArr);
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany",
      ExhibitionIdArr: "getExhibitionIdArr",
    }),
    // exhibitionId() {
    //   return config.ExhibitionId;
    // },
  },
  methods: {
    ...mapMutations({
      setRole: "setRole",
      setUser: "setUser",
      setToken: "setToken",
      setTokenTime: "setTokenTime",
      setLogin: "setLogin",
      setCompany: "loginModule/setCompany",
      setExhibition: "loginModule/setExhibition",
      setJoinInfo: "loginModule/setJoinInfo",
    }),
    ...mapActions({
      getAllConfiSettle: "getAllConfiSettle",
      getUser: "loginModule/getUser",
      getToken: "loginModule/getToken",
      getCompany: "loginModule/getCompany",
      getImgCode: "loginModule/getImgCode",
      validateImgCode: "loginModule/validateImgCode",
      getExhibitionById: "exhibitionModule/getExhibitionById",
      getDefaultJoinExhibition: "companyModule/getDefaultJoinExhibition",
      getJoinInfo: "loginModule/getJoinInfo",
      getExIdByUserId: "loginModule/getExIdByUserId",
      getVerCode: "companyModule/getVerCode",
      asyncVerCode: "companyModule/asyncVerCode",
      editVerCode: "companyModule/editVerCode",
      getInfoByUsername: "companyModule/getInfoByUsername",
      getEmailVerCode: "exhibitionModule/getEmailVerCode",
      getMsgCode: "exhibitionModule/getMsgCode",
      changeEmailOldToken: "companyModule/changeEmailOldToken", // （原邮箱不为空） 发送验证码
      validatePhoneOrEmail: "companyModule/validatePhoneOrEmail", // 验证手机号和邮箱是否正确
    }),
    hidePrivacyPolicy() {
      this.showPrivacyPolicy = false;
    },
    init() {
      let name = this.$cookies.get("name");
      let pwd = this.$cookies.get("pwd");
      if (name && pwd) {
        let password = CryptoJS.AES.decrypt(pwd, "GY-key").toString(CryptoJS.enc.Utf8);
        // console.log("解密结果：" + password);
        this.remember = true;
        this.formInline.user = name;
        this.formInline.password = password;
      }
    },
    cancel() {
      this.resetShow3 = false;
      this.resetShow1 = false;
      (this.formReset1.phone = ""), this.$refs.formReset1.resetFields();
    },
    cancel2() {
      this.resetShow2 = false;
      (this.formReset2.newPhone = ""), this.$refs.formReset2.resetFields();
    },

    async reset(name) {
      let valid = await this.validForm(name);
      if (!valid) return;
      let req = {
        Phone: this.formReset1.phone,
        token: this.formReset1.captcha,
      };
      let bool = await this.asyncVerCode(req);
      if (!bool || !bool.successed) {
        if (bool.errors[0].description) {
          this.$Message.warning(bool.errors[0].description);
        } else {
          this.$Message.warning("验证码错误，请重试！");
        }
        return;
      }
      this.passedPhone = this.formReset1.phone;
      this.passedCaptcha = this.formReset1.captcha;
      this.cancel();
      this.resetShow2 = true;
    },
    async reset2(name) {
      let valid = await this.validForm(name);
      if (!valid) return;
      let req = {
        Phone: this.passedPhone,
        Token: this.passedCaptcha,
        NewPassword: this.formReset2.newPhone,
      };
      let bool = await this.editVerCode(req);
      if (bool && bool.successed) {
        this.$Message.success("修改成功！");
        this.cancel2();
      } else {
        if (bool.errors[0].description) {
          this.$Message.warning(bool.errors[0].description);
        } else {
          this.$Message.warning("修改失败，请重试！");
        }
      }
    },
    async handleSubmit(name) {
      let form = this.formInline;
      let valid = await this.validForm(name);
      if (!valid) return;
      let codeValid = await this.validCode();
      if (!codeValid) return;
      let formData = {
        grant_type: "password",
        client_id: "cloud.exhibition",
        client_secret: "secret",
        username: form.user,
        password: form.password,
        scope: "synair offline_access",
      };
      this.loading = true;
      setTimeout((c) => {
        this.loading = false;
      }, 5000);
      let tokenData = await this.getToken(formData);
      if (tokenData) {
        this.setRole(0);
        this.setToken(tokenData.access_token);
        this.setTokenTime(tokenData.expires_in * 1000 + new Date().getTime());
        let user = await this.getUser();
        this.userInfo = user;
        let company = await this.getCompany(user.id);
        if (!company) {
          // this.$router.push("/exhibition/register-company");
          this.$Message.warning("未绑定公司信息！");
          return;
        } else {
          this.setCompany(company);
          console.log("公司信息：", company, user);
          let idInfo = await this.getExIdByUserId(user.id);
          console.log(idInfo, "idInfo.ExhibitionId");
          if (idInfo && idInfo.ExhibitionId) {
            console.log(this.ExhibitionIdArr, "idInfo.ExhibitionId");
            if (this.ExhibitionIdArr.indexOf(idInfo.ExhibitionId) !== -1) {
              this.exhibitionId = idInfo.ExhibitionId;
              // let exhibition = await this.getDefaultJoinExhibition(company.id);
              let exData = await this.getExhibitionById(this.exhibitionId);
              this.setExhibition(exData);
              console.log("展会信息：", exData);
              this.setLogin(true);
              let joinInfo = await this.getJoinInfo({
                ExhibitionId: this.exhibitionId,
              });
              if (joinInfo) {
                this.setJoinInfo(joinInfo.info);
                // 保存密码
                if (this.remember) {
                  let pwd = CryptoJS.AES.encrypt(
                    String(form.password),
                    "GY-key"
                  ).toString();
                  // console.log("加密结果"+ pwd);
                  this.$cookies.set("name", form.user, 60 * 60 * 24 * 7);
                  this.$cookies.set("pwd", pwd, 60 * 60 * 24 * 7);
                } else {
                  this.$cookies.remove("name");
                  this.$cookies.remove("pwd");
                }
                this.$Message.success("登录成功");
                this.$router.push("/exhibition/index/home");
                localStorage.setItem("password", form.password);
              } else {
                this.$Message.warning("未绑定展会信息！");
              }
            } else {
              this.$Message.warning("未绑定展会信息！！");
            }
          } else {
            this.$Message.warning("未绑定展会信息！！！");
          }
        }
      }
      this.loading = false;
    },
    async getCode() {
      // 获取code
      this.code = await this.getImgCode();
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate((valid) => {
          resolve(valid);
        });
      });
    },
    validField(name) {
      // 验证单个表单
      return new Promise((resolve, reject) => {
        this.$refs.formReset1.validateField(name, (valid) => {
          resolve(valid);
        });
      });
    },
    async validCode() {
      // 验证code
      if (!this.code || !this.formInline.captcha) return false;
      let valid = await this.validateImgCode({
        Key: this.code.key,
        Code: this.formInline.captcha,
      });
      if (!valid) {
        this.$Message.error("验证未通过!");
        return false;
      }
      if (valid.errors && valid.errors[0]) {
        this.$Message.error(valid.errors[0].description);
        this.getCode();
        return false;
      }
      return true;
    },
    linkHost() {
      location.href = "/#/host/login/alogin";
    },

    linkEn() {
      location.href = "/exhibitionen/login/alogin";
    },
    // 忘记密码
    async openRetrievePasswordHandle() {
      // 验证表单中用户名是否填写
      this.$refs.formInline.validateField("user", async (valid) => {
        if (valid) return;
        let bool = await this.getInfoByUsername({ userName: this.formInline.user });
        if (bool && bool.successed) {
          this.userData = bool.info;
          this.retrievePasswordVisible = true;
        } else {
          if (bool.errors[0].description) {
            this.$Message.warning(bool.errors[0].description);
          } else {
            this.$Message.warning("修改失败，请重试！");
          }
        }
      });
    },
    forgotPasswordCancel() {
      this.forgotPasswordVisible = false;
      this.changePasswordType = "";
      this.count = "";
      this.timer = null;
    },
    // 修改手机号 or 邮箱提交
    async forgotPasswordSubmitHandle() {
      let opt = {
        userName: this.formReset1.user,
        vcode: this.formReset1.captcha,
      };
      if (this.changePasswordType == "phone") {
        opt.phoneNumber = this.formReset1.phone;
      } else {
        opt.email = this.formReset1.email;
      }
      let bool = await this.validatePhoneOrEmail(opt);

      if (bool && bool.successed) {
        this.password = bool.info.loginPassWord;
        this.$Message.success("验证成功");
        this.forgotPasswordCancel();
        // this.changePasswordVisible = true;
      } else {
        if (bool.errors[0].description) {
          this.$Message.warning(bool.errors[0].description);
        } else {
          this.$Message.warning("修改失败，请重试！");
        }
      }
    },
    openChangePassword(type) {
      this.changePasswordType = type;
      // this.changePasswordVisible = true;
    },
    resetForm() {
      this.userData = { phone: "", email: "", user: "" };
      this.retrievePasswordVisible = false;
    },
    // 获取验证码
    async getCaptcha(name) {
      let valid1 = null;
      if (this.changePasswordType == "phone") {
        valid1 = await this.validField("phone");
      } else {
        valid1 = await this.validField("email");
      }
      let valid2 = await this.validField("user");
      if (valid1 || valid2) return;
      this.changePasswordType == "phone" && this.downTimeMob(name);
      this.changePasswordType == "email" && this.downTime(name);
    },
    async downTime() {
      let opt = {
        Email: this.formReset1.email,
        Language: "2",
      };
      const valid = await this.getEmailVerCode(opt);
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.showCode = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.showCode = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    async downTimeMob() {
      let opt = {
        Phone: this.formReset1.phone,
        Language: "2",
      };
      const valid = await this.getMsgCode(opt);
      console.log(valid, "123");
      if (!valid.successed) {
        this.$Message.warning("请输入有效手机号");
      }
      const TIME_COUNT = 60;
      console.log(this.timer);
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.showCode = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.showCode = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.login-content-box {
  width: 360px;
  height: 420px;
  background-color: #fff;
  border-radius: 2px;
  // background: rgba(0, 0, 0, 0.3);
  position: absolute;
  right: -25%;
  bottom: 35%;
  display: flex;
  align-items: center;
  justify-content: center;

  &-1 {
    width: 360px;
    height: 420px;
    background-color: #fff;
    box-shadow: 0px 0px 10px 0px rgba(139, 140, 140, 0.3);
    border-radius: 2px;
    position: relative;

    &-top {
      width: 340px;
      height: 40px;
      position: absolute;
      top: 20px;
      left: 43px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .p1 {
        width: 91px;
        height: 17px;
        font-size: 18px;
        line-height: 16px;
        color: #808080;
        cursor: pointer;
        font-weight: bold;
      }

      .p2 {
        width: 100%;
        text-align: center;
        height: 19px;
        font-size: 18px;
        line-height: 16px;
        color: #d13119;
        cursor: pointer;
        font-weight: bold;
      }

      .p3 {
        color: #808080;

        &:hover {
          color: #d13119;
        }
      }
    }

    &-bottom {
      width: 300px;
      height: 350px;
      position: absolute;
      top: 49px;
      left: 29px;
    }
  }

  .wx-icon {
    width: 22px;
    height: 22px;
    padding: 3px 5px;
    background-color: #3eb135;
    border-radius: 50%;
    display: inline-block;
    margin-right: 8px;

    img {
      width: 13px;
      height: 11px;
    }
  }
}

.F {
  display: flex;
  flex-direction: column;
  width: 300px;
  height: 350px;
  position: relative;

  &-1 {
    margin-top: 15px;
    margin-bottom: 0;

    .I {
      margin-top: 19px;
    }
  }

  .F-2 {
    width: 100%;
    height: 15px;
    line-height: 15px;
    display: flex;
    justify-content: space-between;
    margin: 24px 0;

    .F-2-text {
      width: 48px;
      height: 13px;
      font-size: 12px;
      color: #333;
      cursor: pointer;
    }
  }

  .wx-btn {
    margin-top: 20px;
  }

  .code {
    width: 70px;
    height: 26px;
    position: absolute;
    top: 22px;
    right: 8px;
    cursor: pointer;
  }
}

.login-content-text {
  position: absolute;
  left: -25%;
  bottom: 48%;
  color: #db2a4b;

  h3 {
    font-size: 50px;
    margin-bottom: 80px;
  }

  p {
    font-size: 20px;
    font-weight: bold;
  }
}

/deep/ .newPas {
  .ivu-modal-body {
    padding: 24px 0 0 16px;
  }
}

/deep/ .vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right:100px;

  .ivu-modal {
    top: 0;
  }
}

.button {
  width: 120px;
  height: 40px;
  background-color: #d13119;
  border-radius: 4px;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px auto 40px;
  margin-bottom: 10px;
  cursor: pointer;
}

.privacy-policy {
  position: fixed;
  z-index: 9999;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #fff;
  padding: 20px;
}

.privacy-link {
  position: fixed;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  cursor: pointer;
  color: blue;
}
</style>
